import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import debounce from 'lodash.debounce';

// Components
import { Spin, Modal, Form, Row, Col, Alert, Select, Input, InputNumber } from 'antd';

// Actions
import { fetchOwnerList, onAddNewHome, onEditHome } from '../../data/homes/actions';

// Selectors
import {
    getAddOrEditHomeModalIsLoading,
    getAddOrEditHomeModalIsEdit,
    getAddOrEditHomeModalSelectedHome,
    getHomeOwnersListIsLoading,
    getHomeOwnersListData
} from '../../data/homes/selectors';

// Constants
import { MODAL_SIZES } from '../../constants/modal';

class AddOrEditHomeModal extends PureComponent {
    constructor(props) {
        super(props);
        this.debounceSearchValue = debounce(this.handleSearchOnChange, 700);
    }

    state = {
        inviteEmailIsShown: false
    };

    componentWillMount() {
        const { isAdmin } = this.props;
        if (isAdmin) {
            const { fetchOwnerList } = this.props;
            fetchOwnerList();
        }
    }

    handleSearchOnChange = value => {
        const { fetchOwnerList } = this.props;
        fetchOwnerList(value);
    };

    handleSubmit = () => {
        const { form } = this.props;

        form.validateFields((err, values) => {
            if (err) {
                return;
            }

            const {
                isEdit,
                selectedHome,
                msgs,
                onAddNewHome,
                isUsedInAdmin = false,
                onEditHome
            } = this.props;
            const { inviteEmailIsShown } = this.state;

            const enhancedValues = {
                ...values,
                ownerUser: isUsedInAdmin
                    ? {
                          email: inviteEmailIsShown ? values.inviteUserEmail : values.ownerUser.email
                      }
                    : undefined,
                inviteUserEmail: undefined
            };
            if (!isEdit) {
                onAddNewHome(enhancedValues, isUsedInAdmin).catch(() => {
                    form.setFieldsValue({
                        hasError: msgs.homes.addHomeError
                    });
                });
            } else {
                onEditHome(selectedHome.get('home'), enhancedValues, isUsedInAdmin).catch(() => {
                    form.setFieldsValue({
                        hasError: msgs.homes.editHomeError
                    });
                });
            }
        });
    };

    handleAlertClose = () => {
        const { form } = this.props;
        form.setFields({
            hasError: {
                value: undefined
            }
        });
    };

    onShowInviteEmail = isShown => () => {
        this.setState({ inviteEmailIsShown: isShown });
    };

    render() {
        const {
            form,
            isShown,
            isLoading,
            msgs,
            onCancel,
            isAdmin,
            ownerListIsLoading,
            ownerListData,
            isEdit = false,
            selectedHome = undefined
        } = this.props;

        const { inviteEmailIsShown } = this.state;
        const { getFieldValue, getFieldDecorator } = form;
        return (
            <Modal
                key="admin-users-modal-add-or-edit"
                visible={isShown}
                confirmLoading={isLoading}
                width={MODAL_SIZES.MEDIUM}
                title={
                    !isEdit
                        ? msgs.homes.addHome
                        : `${msgs.homes.editHome} - ${selectedHome ? selectedHome.get('name') : ''}`
                }
                onCancel={onCancel}
                onOk={this.handleSubmit}
                cancelText={msgs.cancel}
                okText={msgs.save}
            >
                <Spin spinning={isLoading} size="large">
                    <Form>
                        {getFieldValue('hasError') && (
                            <Row>
                                <Col xs={24}>
                                    <Alert
                                        message={getFieldValue('hasError')}
                                        type="error"
                                        showIcon
                                        closable
                                        onClose={this.handleAlertClose}
                                    />
                                </Col>
                            </Row>
                        )}
                        <Row gutter={8}>
                            <Col xs={24}>
                                <Form.Item label={msgs.homes.name}>
                                    {getFieldDecorator('name', {
                                        initialValue:
                                            isEdit && selectedHome.get('name')
                                                ? selectedHome.get('name')
                                                : undefined,
                                        rules: [{ required: true, message: msgs.requiredField }]
                                    })(<Input type="text" />)}
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={8}>
                            <Col xs={24}>
                                <Form.Item label={msgs.homes.postalCode}>
                                    {getFieldDecorator('postalCode', {
                                        initialValue:
                                            isEdit && selectedHome.get('postalCode')
                                                ? selectedHome.get('postalCode')
                                                : undefined,
                                    })(<Input type="text" />)}
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={8}>
                            <Col xs={24}>
                                <Form.Item label={msgs.homes.kwLimit}>
                                    {getFieldDecorator('kwLimit', {
                                        initialValue:
                                            isEdit && selectedHome.get('kwLimit')
                                                ? parseFloat(selectedHome.get('kwLimit'))
                                                : undefined,
                                    })(<InputNumber type="long" style={{ width: '100%' }} />)}
                                </Form.Item>
                            </Col>
                        </Row>
                        {isAdmin && (
                            <Row gutter={8}>
                                <Col xs={24}>
                                    <Form.Item
                                        label={msgs.homes.detail.owner}
                                        extra={
                                            <p style={{ textAlign: 'center' }}>
                                                <a
                                                    href
                                                    onClick={this.onShowInviteEmail(!inviteEmailIsShown)}
                                                >
                                                    + {msgs.adminAddUser}
                                                </a>
                                            </p>
                                        }
                                    >
                                        {getFieldDecorator('ownerUser.email', {
                                            initialValue:
                                                isEdit && selectedHome.get('ownerUser')
                                                    ? selectedHome.getIn(['ownerUser', 'email'])
                                                    : undefined,
                                            rules: [{ required: true, message: msgs.requiredField }]
                                        })(
                                            <Select
                                                showSearch
                                                disabled={inviteEmailIsShown}
                                                placeholder={msgs.homes.detail.owner}
                                                notFoundContent={
                                                    ownerListIsLoading ? (
                                                        <span>
                                                            <Spin size="small" /> {msgs.loading}
                                                        </span>
                                                    ) : null
                                                }
                                                filterOption={false}
                                                onSearch={this.debounceSearchValue}
                                                style={{ width: '100%' }}
                                            >
                                                {ownerListData.map(owner => (
                                                    <Select.Option
                                                        key={`owner-${owner.get('id')}`}
                                                        value={owner.get('email')}
                                                    >
                                                        {owner.get('email')}
                                                    </Select.Option>
                                                ))}
                                            </Select>
                                        )}
                                    </Form.Item>
                                </Col>
                                {inviteEmailIsShown && (
                                    <Col xs={24}>
                                        <Form.Item label={msgs.auth.emailLabel}>
                                            {getFieldDecorator('inviteUserEmail', {
                                                initialValue: undefined,
                                                rules: [
                                                    { required: true, message: msgs.requiredField },
                                                    {
                                                        type: 'email',
                                                        required: true,
                                                        message: msgs.emailFormatField
                                                    }
                                                ]
                                            })(<Input type="email" />)}
                                        </Form.Item>
                                    </Col>
                                )}
                            </Row>
                        )}
                    </Form>
                </Spin>
            </Modal>
        );
    }
}

export default connect(
    (state, ownProps) => ({
        ...ownProps,
        isLoading: getAddOrEditHomeModalIsLoading(state),
        isEdit: getAddOrEditHomeModalIsEdit(state),
        selectedHome: getAddOrEditHomeModalSelectedHome(state),
        ownerListIsLoading: getHomeOwnersListIsLoading(state),
        ownerListData: getHomeOwnersListData(state)
    }),
    {
        fetchOwnerList,
        onAddNewHome,
        onEditHome
    }
)(Form.create()(AddOrEditHomeModal));